import React from 'react';
import styled from 'styled-components';

export default function ChatingGuest() {
    return(
        <Chatingarea >
        </Chatingarea>
    )
}
const Chatingarea = styled.div`
    background: #f7f7f7;
    height: 100%;
    min-height: 100vh;
    padding : calc(100vw*(84.5/375)) 0 calc(100vw*(70/375));
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    overflow-y: scroll;
`